<template>
  <section class="grid-flex column">
    <div class="grid-flex w100 column margin-top-l no-mobile">
      <div class="flex w100 middle">
        <div class="flex-1">
          <div v-if="!loading">
            <h3>
              {{ funnel.name }}
            </h3>
          </div>
          <div v-else>
            <content-loading>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
        <div class="flex-1 flex end">
          <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
        </div>
      </div>
      <div  ref="divcontainer" class="flex-1 center-txt w100">
        <div class="box margin-top-l ">
          <div class="box-content custom-card">
            <div v-if="!loadingReport" class="flex row w100">
              <vue-funnel-graph
                v-if="funnelData.values && funnelData.values.length > 0"
                :width="funnelData.width"
                :height="funnelData.height"
                :labels="funnelData.labels"
                :values="funnelData.values"
                :colors="funnelData.colors"
                :sub-labels="funnelData.subLabels"
                :direction="funnelData.direction"
                :gradient-direction="funnelData.gradientDirection"
                :animated="true"
                :display-percentage="true"
              ></vue-funnel-graph>
            </div>
            <div v-else class="w100">
              <content-loading>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
                <fake-line height="30"></fake-line>
              </content-loading>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 margin-top-l w100">
        <div class="">
          <h3>Vendas</h3>
        </div>
        <div class="grid-flex wrap">
          <div class="item flex-1">
            <box-info
              icon="fab fa-facebook"
              bigIcon="True"
              label="Custo de Marketing FBADS"
              tooltip="Somatório de custos de campanhas ATIVAS FACEBOOK ADS"
              :value="stats.sales.approved"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="item flex-1">
            <box-info
              icon="fab fa-google"
              bigIcon="True"
              label="Custo de Marketing GADS"
              tooltip="Somatório de custos de campanhas ATIVAS GOOGLE ADS"
              :value="stats.sales.sales"
              :money="true"
              :currency="filters.data.currency"
            >
            </box-info>
          </div>

          <div class="item flex-1">
            <box-info
              icon="fas fa-balance-scale"
              label="ROAS"
              tooltip="Retorno Sobre o Investimento em Marketing (Receita Líquida) / (Somátorio de Marketing)"
              :value="stats.sales.sales_approved"
              suffix="x"
            >
            </box-info>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";

import { VueFunnelGraph } from "vue-funnel-graph-js";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";
import boxInfo from "@/components/boxInfo/BoxInfo";

import {
  getFunnel,
  getFunnelReport,
} from "@/services/funnel";

export default {
  name: "funnel-detail",
  components: {
    VueFunnelGraph,
    ltkDatePicker,
    boxInfo
  },
  props: ['funnel_id'],
  data() {
    return {
      loading: false,
      loadingReport: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
        },
        list: {},
      },
      stats: {},
      funnel: {},
      funnelData: {
        labels: [
          // "Impressions",
          "Page View",
          "Add To Cart",
          "Initiate checkout",
          "Add Payment info",
          "Purchase",
        ],
        subLabels: [],
        values: [],
        colors: [
          ["#47265a", "#000"],
          ["#A0BBFF", "#EC77FF"],
          ["#A0F9FF", "#7795FF"],
        ],
        direction: "horizontal",
        gradientDirection: "horizontal",
        height: 300,
        width: 1024,
      },
    };
  },
  mounted() {
    this.getFunnel();
    this.getFunnelReport();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.getFunnelReport()
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    getFunnel() {
      this.loading = true;
      getFunnel(this.funnel_id)
        .then((result) => {
          this.funnel = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFunnelReport() {
      if (this.loadingReport) {
        return
      }

      this.loadingReport = true;
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      };

      getFunnelReport(this.funnel_id, params)
        .then((result) => {
          this.funnelData.labels = result.funnel_data.labels;
          this.funnelData.subLabels = result.funnel_data.subLabels;
          this.funnelData.values = result.funnel_data.values;

          this.stats = result.stats

        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loadingReport = false;
        });
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

</style>
